'use client';
import { LDContext, LDProvider } from 'launchdarkly-react-client-sdk';
import { PropsWithChildren } from 'react';
import { useGetUserQuery } from '../api';

export const LDFeatureFlagProvider = ({ children }: PropsWithChildren) => {
  let context: LDContext = {
    kind: 'user',
    key: 'test-user-1',
  };
  const { data: user, isLoading } = useGetUserQuery();

  if (isLoading) {
    <div className="h-[calc(100vh-64px)] flex justify-center items-center">
      <div className="border-t-transparent border-solid animate-spin rounded-full border-primary-800 border-4 h-16 w-16"></div>
    </div>;
  }

  if (!user) {
    context = {
      kind: 'user',
      key: 'anomymous',
      userId: 'unknown',
      orgId: 'unkown',
    };
  } else {
    context = {
      kind: 'user',
      key: user.userId,
      userId: user.userId,
      orgId: user.orgId,
    };
  }

  return (
    <LDProvider
      context={context}
      clientSideID={process.env.NEXT_PUBLIC_LD_CLIENT_SIDE_ID ?? ''}
    >
      {children}
    </LDProvider>
  );
};
